"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const LocalStorage = {
  set: (key, value) => {
    localStorage.setItem(key, value);
    return Promise.resolve();
  },
  get: key => {
    return Promise.resolve(localStorage.getItem(key));
  },
  remove: key => {
    localStorage.removeItem(key);
    return Promise.resolve();
  },
  clear: () => {
    localStorage.clear();
    return Promise.resolve();
  }
};
var _default = LocalStorage;
exports.default = _default;